export const calculateProductPoints = (rules, quantity) => {
    return rules.reduce((prev, current) => {
        return prev + current.points * (current.multiply ? quantity : 1);
    }, 0);
};
export default calculateProductPoints;
//# sourceMappingURL=calculateProductPoints.js.map